<template>
  <!-- Mystics moved second (Chris 2026-11-03): the top of Lessons keeps their
       Mystics one tap away. -->
  <nav v-if="list.length" class="ym" aria-label="Your Mystics" data-testid="your-mystics-row">
    <button
      v-for="m in list" :key="m.sub_domain" type="button" class="ym-f"
      data-testid="your-mystic" :data-sub="m.sub_domain" :aria-label="m.name"
      @click="$emit('open-mystic', m.sub_domain)"
    >
      <span class="ym-im">
        <img v-if="m.art" :src="m.art" alt="" loading="lazy" draggable="false" />
      </span>
      <span class="ym-nm">{{ m.short }}</span>
    </button>
  </nav>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { store } from '@/store'
import { getMysticsTab } from '@/api-service'
import { shortName } from '@/utils/mystics-tab'

defineEmits(['open-mystic'])
const list = ref([])

onMounted(async () => {
  if (!store.querent_id) return
  try {
    const body = await getMysticsTab(store.session_id)
    const by = Object.fromEntries((body.readers || []).map((r) => [r.sub_domain, r]))
    list.value = ((body.mine && body.mine.order) || []).filter((s) => by[s]).map((s) => ({
      sub_domain: s,
      name: by[s].name || '',
      short: shortName(by[s]),
      art: by[s].avatar_image || by[s].background_image || '',
    }))
  } catch (e) {
    list.value = []   // Lessons stays as built
  }
})
</script>

<style scoped>
.ym { display: flex; justify-content: safe center; gap: 14px; max-width: 760px; margin: 0 auto; padding: 14px 20px 2px; overflow-x: auto; scrollbar-width: none; }
.ym::-webkit-scrollbar { display: none; }
.ym-f { flex: none; width: 68px; padding: 0; border: 0; background: none; cursor: pointer; color: #e8d8ff; }
.ym-im { display: block; width: 56px; height: 56px; margin: 0 auto; border-radius: 12px; overflow: hidden; background: #2a1650; border: 1px solid rgba(231, 201, 131, .55); transition: border-color .15s, transform .15s; }
.ym-f:hover .ym-im { border-color: #ffdfa3; transform: translateY(-1px); }
.ym-f:focus-visible { outline: 2px solid #e7c983; outline-offset: 3px; border-radius: 12px; }
.ym-im img { display: block; width: 100%; height: 100%; object-fit: cover; }
.ym-nm { display: block; margin-top: 5px; font: 500 11.5px/1.2 Inter, system-ui, sans-serif; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
@media (prefers-reduced-motion: reduce) { .ym-im { transition: none; } }
</style>
